/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Session_TodayInputs */

const en_us2_plan_session_today = /** @type {(inputs: Plan_Session_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const pt_br2_plan_session_today = /** @type {(inputs: Plan_Session_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje`)
};

const es_419_plan_session_today = /** @type {(inputs: Plan_Session_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy`)
};

const pt_pt2_plan_session_today = /** @type {(inputs: Plan_Session_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje`)
};

const fr_fr2_plan_session_today = /** @type {(inputs: Plan_Session_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui`)
};

const de_de2_plan_session_today = /** @type {(inputs: Plan_Session_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute`)
};

const it_it2_plan_session_today = /** @type {(inputs: Plan_Session_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Plan_Session_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_session_today = /** @type {((inputs?: Plan_Session_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Session_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_session_today(inputs)
	if (locale === "es-419") return es_419_plan_session_today(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_session_today(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_session_today(inputs)
	if (locale === "de-DE") return de_de2_plan_session_today(inputs)
	if (locale === "it-IT") return it_it2_plan_session_today(inputs)
	return en_us2_plan_session_today(inputs)
});
export { plan_session_today as "plan.session_today" }